module.exports = __webpack_public_path__ + "static/choose-shapyer-option-94ec44b468f32ce25d40617b41ba07b2.png";